var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3"},[_c('UplimitStepWithNextDay',{on:{"show_sidebar":_vm.show_sidebar}}),_c('StockInfoSidebar',{attrs:{"symbol_code":_vm.symbol_code,"symbol_name":_vm.symbol_name,"date_mark":_vm.date_mark},on:{"date-mark-change":_vm.onDateMarkChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }